import React from 'react';
import IntlMessage from "../../../../../helpers/intlMessage";

import Td from './Td';

function Table ({item}) {
  return (
    <table style={{width: '100%', marginBottom: '7px'}}>
      <tbody>
        <tr>
          <Td colSpan='2' title={<IntlMessage id = "dashboards.taskControl.patient"/>} value={item.nomePaciente}/>
          <Td colSpan='3' title={<IntlMessage id = "dashboards.general.socialName"/>} value={item.pacienteNomeSocial}/>
        </tr>
        <tr>
          <Td colSpan='5' title={<IntlMessage id = "dashboards.taskControl.pathologistDoctor"/>} value={item.medicoNome}/>
        </tr>
        <tr>
          <Td colSpan='5' title={<IntlMessage id = "dashboards.taskControl.technicalManager"/>} value={item.nomeTecnico}/>
        </tr>
        <tr>
          <Td title={<IntlMessage id = "dashboards.taskControl.blade"/>} value={item.nrLamina} styleTd={{width: '50px'}}/>
          <Td title={<IntlMessage id = "dashboards.taskControl.bladeType"/>} value={item.tipoLamina} styleTd={{width: '50px'}}/>
          <Td title={<IntlMessage id = "dashboards.taskControl.coloring"/>} value={item.coloracao} styleTd={{width: '50px'}}/>
          <Td title={<IntlMessage id = "dashboards.taskControl.status"/>} value={item.finalizacao} styleTd={{width: '50px'}}/>
          <Td title={<IntlMessage id = "dashboards.taskControl.canceled"/>} value={item.cancelada} styleTd={{width: '50px'}}/>
        </tr>
      </tbody>
    </table>
  );
}

export default Table;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Histologia/Impressao/Table/index.js